/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Radio, Table} from '@scuf/common';
import {SYMPTOM_STATES} from "./common/FaultsConst";
import {bindActionCreators} from "redux";
import * as FaultActions from "./FaultActions";
import * as SecurityActions from '../security/SecurityActions'
import {verifyAirtimeException} from "../utils/Helpers";

class ConfigurationSymptoms extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            symptoms: this.props.configSymptoms,
        }
        this.setSymptomValue = this.setSymptomValue.bind(this)
    }

    getSymptomsRows(symptoms, disabled, faultId, assetId) {
        return symptoms.map((o, i) => {
            const realState = o.newState || o.state
            return (
                <React.Fragment key={o.id}>
                    <Table.Row className={this.getRowClass("", i)}>
                        <Table.Cell className="computer only">
                            {o.description}
                        </Table.Cell>
                        <Table.Cell className="mobile only">
                            {o.description}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getSymptomRadioButton(o.id, SYMPTOM_STATES.PRESENT, realState, disabled, faultId, assetId)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getSymptomRadioButton(o.id, SYMPTOM_STATES.ABSENT, realState, disabled, faultId, assetId)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getSymptomRadioButton(o.id, SYMPTOM_STATES.UNKNOWN, realState, disabled, faultId, assetId)}
                        </Table.Cell>
                    </Table.Row>
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    getSymptomRadioButton(id, value, currentValue, disabled, faultId, assetId) {
        return (
            <Radio
                name={'configuration-symptom-'+id}
                checked={currentValue === value}
                onChange={() => this.setSymptomValue(id, value, faultId, assetId)}
                disabled={disabled}
            />
        )
    }

    setSymptomValue(id, value, faultId, assetId) {
        this.props.FaultActions.submitConfigSymptom(assetId, faultId, id, value).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    render() {
        const {intl, fault} = this.props

        if (this.props.configSymptoms == null || this.props.configSymptoms.length <= 0) {
            return <FormattedMessage id={"fault.detail.configurationSymptoms.notAvailable"}/>
        }

        const rows = this.getSymptomsRows(this.props.configSymptoms, this.props.disabled, fault.faultId, fault.assetId);

        return (
            <div id="configuration-symptoms-step">
                <Table className="unstackable">
                    <Table.Header>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.detail.title.configurationSymptoms"})} className="mobile only"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.detail.title.configurationSymptoms"})} className="computer only"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.present"})} textAlign="center" className="radio-cell"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.absent"})} textAlign="center" className="radio-cell"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.unknown"})} textAlign="center" className="radio-cell"/>
                    </Table.Header>
                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigurationSymptoms)))